import { Keyboard } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const GROUPS = [
  { title: "Wake word (Apex open, wake word on)", items: [
    ["Hey Apex, brief me", "Runs the morning briefing straight away"],
    ["Hey Apex, <any command>", "e.g. \"Hey Apex, what jobs do I have today?\""],
    ["Stop / wait / hang on", "Interrupts Apex mid-sentence"],
  ]},
  { title: "Your day", items: [
    ["Brief me", "Today's jobs, addresses, history and past fixes (plays automatically on your first open before 12pm)"],
    ["What jobs do I have today?", "Today's schedule in time order"],
    ["What did I log today?", "Hours logged today, by job"],
    ["Weekly summary", "This week's hours by customer, open jobs and unbilled time"],
  ]},
  { title: "Logging & closing", items: [
    ["…describe the job… then \"Log it\"", "Apex fills in customer, times and notes, reads it back and logs on \"yes\""],
    ["Close the Smith job, I was there 2 till 3:30, replaced the SSD", "Closes the job and logs the time"],
    ["Add 30 minutes travel for Smith today", "Extra time entry"],
    ["Change that entry to finish at 4pm", "Edit a time entry"],
  ]},
  { title: "Scheduling", items: [
    ["Book Jane Smith Thursday 10am, printer setup", "Create a job"],
    ["Move the Smith job to Friday 2pm", "Reschedule"],
    ["Give Friday's jobs to Ben", "Bulk reassign (Apex reads them back first)"],
    ["Delete the Smith job", "Delete a job"],
    ["Resend the email for Smith", "Re-send the job email to the customer"],
  ]},
  { title: "Customers & faults", items: [
    ["Tell me about <customer>", "Full job history, past fixes and repeat faults"],
    ["Mark it no-charge", "Repeat fault → warranty / no charge"],
    ["I rang Jane, the printer's been fine", "Saves the check-in call note and ticks off the follow-up (if the problem's back, Apex offers a no-charge job)"],
  ]},
  { title: "Invoicing (Ben & accounts)", items: [
    ["What's ready to invoice?", "Closed jobs with contact, hours and work done — also \"last week\", \"this month\" or dates"],
    ["Mark Smith as invoiced", "Stamps INVOICED on the job so it drops off the list"],
    ["Smith paid cash", "Sets the time to cash, stamps PAID CASH, closes the job and takes it off the invoice list"],
    ["Set the hourly rate to $X", "Used for invoice totals (15-min increments, + 10% GST)"],
    ["50% off Stan's job", "Discount a job — totals show original price, discount and new price"],
    ["…then tap \"Download PDF\"", "Under any ready-to-invoice reply, for printing or attaching"],
    ["What can I say?", "Apex lists these commands"],
  ]},
];

export function CommandsSheet({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="commands-sheet" className="max-w-lg max-h-[85vh] overflow-y-auto bg-[var(--surface)] border-[var(--border)] text-[var(--text-primary)]">
        <DialogHeader>
          <DialogTitle className="font-display text-[var(--primary)] flex items-center gap-2"><Keyboard size={18} /> Apex commands</DialogTitle>
          <DialogDescription className="text-[var(--text-muted)]">Say or type these. Apex always reads back changes and waits for your "yes".</DialogDescription>
        </DialogHeader>
        <div className="space-y-5">
          {GROUPS.map((g) => (
            <div key={g.title}>
              <p className="text-[10px] font-mono-tech uppercase tracking-widest text-[var(--text-muted)] mb-2">{g.title}</p>
              <ul className="space-y-2">
                {g.items.map(([say, what]) => (
                  <li key={say} className="rounded-xl border border-[var(--border)] bg-black/25 px-3 py-2">
                    <p className="text-sm font-semibold text-[var(--primary)]">"{say}"</p>
                    <p className="text-xs text-[var(--text-secondary)] mt-0.5">{what}</p>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
